<template>
    <CRow class="justify-content-center">
      <CCol sm="12" md="12" lg="6">
        <CCard>
          <CCardHeader>
            <strong>Nhập thông tin sản phẩm từ tệp</strong>
            <div class="card-header-actions">
            <CButton type="button" shape="pill" color="secondary" class="mr-1" @click="goBack">
              <CIcon name="cil-chevron-left"/>
              Quay lại</CButton>
          </div>
          </CCardHeader>
          <CCardBody>
            <CForm>

              <CRow>
                <CCol sm="6" md="8" lg="9">
                  <label
                    class="form-control"
                    for="fileInput"
                  >{{ fileName }}
                  </label>
                  <input type="file"
                         name="uploadfile"
                         id="fileInput"
                         style="display: none;"
                         @change="onFileChange">
                </CCol>
                <CCol sm="6" md="4" lg="3">
                  <CButton shape="pill" color="info"
                   style="width: 100%;" @click="handleSubmit"
                   :disabled="isUploading"
                  >
                    <CIcon name="cil-cloud-upload"/>
                    {{ isUploading ? "Đang tải..." : "Tải lên" }}
                  </CButton>
                </CCol>
              </CRow>
            </CForm>

            <CRow v-if="isUploading" class="justify-content-center" style="margin-top: 20px">
              <CSpinner
                color="info"
                style="width:2rem;height:2rem;"
              />
            </CRow>
          </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </template>

  <script>
  export default {
    data() {
      return {
        fileName: 'Duyệt tệp',
        selectedFile: null, // Holds the selected file object
        isUploading: false,
        progress: null,
        eventSource: null,
      };
    },
    methods: {
      handleSubmit() {
        if (!this.selectedFile) {
          this.$swal.fire({
            icon: "error",
            title: "Tải lên",
            text: "Vui lòng chọn tệp trước"
          });
          return;
        }

        // Create FormData instance to hold the file
        this.isUploading = true;
        const formData = new FormData();
        formData.append("file", this.selectedFile);

        // Send file using Axios
        this.$request.post("/api/device/products/import", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.status === 'success') {
              // console.log(res.data.status)
              this.$swal.fire({
                icon: "success",
                title: "Tải lên tệp",
                text: "Tệp: " + this.fileName + " đã tải lên thành công!",
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Tải lên tệp",
                html: "Tệp: " + this.fileName + " tải lên lỗi: " + res.data.status,
              });
            }
            this.isUploading = false;
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Tải lên tệp",
              html: "Tệp: " + this.fileName + " tải lên lỗi: " + error,
            });
            this.isUploading = false;
          });
      },
      onFileChange(event) {
        this.selectedFile = event.target.files[0];
        if (this.selectedFile) {
          this.fileName = this.selectedFile.name;
          // console.log('selected file name:', this.fileName)
        } else {
          // console.log('no file selected');
          this.fileName = 'Duyệt tệp'
        }
      },
      goBack() {
        this.$router.go(-1)
      }
    },
  };
  </script>
